import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        @media (max-width: 768px) {
            padding: 40px 16px;
        }

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 15px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.2em;
                }

                @media (max-width: 480px) {
                    font-size: 1.75em;
                }
            }

            h2.subtitle {
                font-size: 1.5em;
                font-weight: 400;
                margin: 0 0 20px 0;
                opacity: 0.9;
                
                @media (max-width: 768px) {
                    font-size: 1.1em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;

        @media (max-width: 768px) {
            font-size: 0.95em;
            gap: 6px;
        }
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1000px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: -24px auto 0;
            padding: 0 12px;
        }
        
        .info-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;
            box-sizing: border-box;

            @media (max-width: 768px) {
                padding: 24px 16px;
                border-radius: 16px;
                margin-bottom: 24px;
            }

            .images-grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                border-radius: 16px;
                overflow: hidden;
                margin-bottom: 20px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                
                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                    border-radius: 12px;
                }

                .imgwrap {
                    position: relative;
                    width: 100%;
                    height: 300px;

                    @media (max-width: 768px) {
                        height: 220px;
                    }

                    span {
                        position: absolute;
                        color: white;
                        font-weight: bold;
                        font-size: 18px;
                        z-index: 20;
                        bottom: 0;
                        right: 0;
                        padding: 14px;
                        text-shadow: 1px 1px 4px rgba(0,0,0,0.8);

                        @media (max-width: 768px) {
                            font-size: 14px;
                            padding: 10px;
                        }
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }
                }
            }

            .image-note {
                text-align: right;
                font-size: 0.9em;
                color: #64748b;
                margin-bottom: 30px;
                font-style: italic;

                @media (max-width: 768px) {
                    font-size: 0.85em;
                    margin-bottom: 16px;
                }
            }

            .date-info {
                color: #64748b;
                font-size: 0.95em;
                margin-bottom: 30px;
                text-align: right;
                font-style: italic;

                @media (max-width: 768px) {
                    font-size: 0.85em;
                    margin-bottom: 16px;
                }
            }

            .text-content {
                h3 {
                    color: #00A9C4;
                    font-size: 1.8em;
                    margin: 40px 0 20px;
                    font-weight: 700;

                    @media (max-width: 768px) {
                        font-size: 1.35em;
                        margin: 24px 0 12px;
                    }
                }

                p {
                    font-size: 1.15em;
                    line-height: 1.8;
                    color: #334155;
                    margin-bottom: 20px;
                    text-align: justify;

                    @media (max-width: 768px) {
                        font-size: 1em;
                        line-height: 1.65;
                        text-align: left;
                        margin-bottom: 14px;
                    }
                }
            }
        }
    `
};

export default S;